import API, { DATA_API } from 'helpers/api'
import { Grade } from './grade'

export async function getStaffListAskedAdditionalAppointment({
  accountIds,
  filters,
  signal,
}: getStaffListAskedAdditionalAppointmentInput) {
  if (!accountIds.length) {
    return { summary: {}, records: [] } as never as Response
  }

  const data = {
    accountIds,
    filters,
  }

  const source = API.getCancelToken().source()

  const promise = API.get<Response>({
    api: DATA_API,
    url: '/calls/metrics/staff-asked-additional-appointment',
    params: data,
    cancelToken: source.token,
  })

  // Cancel the request if TanStack Query signals to abort
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query')
  })

  return promise
}

export type getStaffListAskedAdditionalAppointmentInput = {
  accountIds: string[]
  filters: {}
  signal?: AbortSignal
}

export type Response = {
  summary: {
    total: number
    askedForAdditionalAppointment: number
    askedForAdditionalAppointmentPercentage: number
    askedForAdditionalAppointmentGrade: Grade
  }
  records: Array<{
    callHandlerId: string
    callHandlerName: string
    total: number
    askedForAdditionalAppointmentTotal: number
    askedForAdditionalAppointmentPercentage: number
    askedForAdditionalAppointmentGrade: Grade
  }>
}
